import React, {useEffect, useRef} from 'react';
import { Typography, Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import s from '../TourDetails/BookingDetailsPage.module.scss';
import {useLocation, useNavigate} from "react-router-dom";

const ConfirmationStep = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const bookingResponse = location.state?.bookingResponse;
    const fired = useRef(false);

    useEffect(() => {
        if (!bookingResponse || fired.current) {
            return;
        }

        const booking = bookingResponse;

        window.dataLayer = window.dataLayer || [];

        // Clear previous ecommerce object
        window.dataLayer.push({
            ecommerce: null
        });

        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                transaction_id: booking.orderNumber,
                value: Number(booking.totalAmount),
                currency: booking.totalCurrency || 'AUD',

                items: booking.items.map(item => ({
                    item_id: item.productCode,
                    item_name: item.productName,
                    price: item.subtotal,
                    quantity: Number(item.totalQuantity)
                }))
            }
        });

        fired.current = true;
    }, [bookingResponse]);

    if (!bookingResponse) {
        return (
            <div className={s.confirmation}>
                <CircularProgress />
                <Typography>
                    予約を処理中...
                </Typography>
            </div>
        );
    }

    return (
        <div className={s.confirmation}>
            <div className={s.confirmationCard}>
                <Typography
                    variant="h3"
                    className={s.confirmation__title}
                >
                    予約完了しました 🎉
                </Typography>

                <Typography variant="h5">
                    予約番号 #
                    {bookingResponse.orderNumber}
                </Typography>

                <Typography>
                    ステータス:
                    {bookingResponse.status}
                </Typography>

                <br />

                <Typography>
                    {bookingResponse.customer?.firstName}{' '}
                    {bookingResponse.customer?.lastName}
                </Typography>

                <Typography>
                    {bookingResponse.customer?.email}
                </Typography>

                <br />

                <Typography variant="h6">
                    合計金額:
                    ${bookingResponse.totalAmount?.toFixed(2)}
                </Typography>

                {bookingResponse.items?.map(
                    (item, i) => (
                        <div key={i}>
                            <hr />

                            <Typography>
                                {item.productName}
                            </Typography>

                            <Typography>
                                {item.startTimeLocal}
                            </Typography>
                        </div>
                    )
                )}

                {bookingResponse.voucherUrl && (
                    <Button
                        variant="contained"
                        href={
                            bookingResponse.voucherUrl
                        }
                        target="_blank"
                    >
                        Voucher PDF
                    </Button>
                )}

                <Button
                    variant="outlined"
                    onClick={() =>
                        navigate('/')
                    }
                >
                    Home
                </Button>
            </div>
        </div>
    );
};

export default ConfirmationStep;